<script>
import { ShoppingCart, Location, Merchant } from './../../functions.js'
import LocationAPI from './../../api/location.js'

import LocationSelection from './LocationSelection.vue'

import ConfirmDialogue from './ConfirmDialogue.vue'

export default {
  name: 'LocationModal',
   props: {
      allowClose: {
      type: Boolean,
        default: true
      }
  },
  data () {
    return {
      submitting: false,
      merchant: {
        merchant_id: 0,
        merchant_weight_limit: 0,
      },

      location: {
        province: {
          province_code: '',
          prodvince_name: '',
        },
        city: {
          city_code: '',
          city_name: '',
        },
        barangay: {
          brgy_name: '',
          brgy_code: '',
        }
      },
       province_list: [],
      city_list: [],
      barangay_list: []
    }
  },
  components: {
    LocationSelection,
    ConfirmDialogue
  },
  methods: {
    closeModal () {
      this.$emit('onClose')
    },
    async loadCities (event) {
      this.city_list = [];
      this.barangay_list = [];
      this.location.city = {
          city_code: '',
          city_name: '',
        };
      this.location.barangay = {
          brgy_name: '',
          brgy_code: '',
        };


      var province_code = event.target.value;
      var province_name = '';

      this.province_list.forEach((p, p_index)=>{
        if(p.psgcCode == province_code)
        {
          province_name = p.provDesc;
        }
      });

      this.location.province = {
        'province_code': province_code,
        'province_name': province_name,
      };


      setTimeout(()=>{
        var city_request = LocationAPI.getCities(province_code)
        city_request.then((response) => {
          if (response.length) {
            this.city_list = response;
          }
        })
      },200);
    },
    async loadBarangay (event) {
      this.barangay_list = [];
      var city_code = event.target.value;
      var city_name = '';

      this.city_list.forEach((c, c_index)=>{
        if(c.citymunCode == city_code)
        {
          city_name = c.citymunDesc;
        }
      });

      this.location.city = {
        'city_code': city_code,
        'city_name': city_name,
      };

      setTimeout(()=>{
        var barangay_request = LocationAPI.getBarangay(city_code)
        barangay_request.then((response) => {
          if (response.length) {
            this.barangay_list = response
          }
        })

      },200);
    },
    async loadLocationData(event)
    {
       var brgy_code = event.target.value;
       var brgy_name = '';

       var merchant_id = 0;
       var merchant_weight_limit = 0;
      
      this.barangay_list.forEach((b, b_index)=>{
        if(b.brgyCode == brgy_code)
        {
          brgy_name = b.brgyDesc;
          merchant_id = b.merchant_id;
          merchant_weight_limit = b.weight_limit;
        }
      });

      this.location.barangay = {
        'brgy_code': brgy_code,
        'brgy_name': brgy_name,
      };

      this.merchant.merchant_id = merchant_id;
      this.merchant.merchant_weight_limit = merchant_weight_limit;

    },
    getLocation (location) {
      this.active_location = location
    },
    async selectLocation () {
        var allow_select_location = false;

         var cart = ShoppingCart.cart[ShoppingCart.active_shopping_cart].products
        if(cart.length)
        {
             var change_product_merchant = await ShoppingCart.changeMerchant(this.location.barangay.brgy_code);
             console.log(change_product_merchant);
             if(change_product_merchant.status == 'success' && change_product_merchant.products.length && !change_product_merchant.updated)
             {
               allow_select_location = true;
             }
             else
             {
                 let displayed_product_data = {
                    subtotal: 0,
                    products: []
                };

                cart.forEach((product,product_index)=>{
                    var p = {
                      product: null,
                      quantity: 0
                    };

                    p.product = product.product;
                    change_product_merchant.products.forEach((new_product, new_product_index)=>{
                        var sku_raw = product.product.sku.substring(0, product.product.sku.indexOf("-"));
                        if(new_product.product.sku.includes(sku_raw))
                        {
                          p.quantity = new_product.new_qty;
                        }
                    });

                    displayed_product_data.subtotal += (p.product.product_price) * p.quantity;
                    displayed_product_data.products.push(p);
                });


                let product_list_message = "<ul class='updated-product-list'>";
                displayed_product_data.products.forEach((dp, dp_i)=>{
                  // if(dp.quantity>0)
                  // {
                    product_list_message = product_list_message + "<li>" + dp.quantity + " x " + dp.product.product_name + "</li>";
                  // }
                });
                product_list_message  = product_list_message + "</ul>";


                let subtotal_message = 'Subtotal: ' + displayed_product_data.subtotal;
                let custom_message = "There was a change in the available stock. Kindly refer to your updated cart. Please click “Proceed” to accept the changes and continue with your order."+product_list_message+"";
                var update_product_merchant  = false;

                if(change_product_merchant.change_quantity == true)
                {
                  update_product_merchant = await this.$refs.confirmDialogue.show({
                      title: "You have items in your Cart",
                      message: custom_message,
                      okButton: 'Proceed',
                      cancelButton: 'Cancel'
                  });
                }
                else
                {
                  update_product_merchant  = true;
                }

                 if(update_product_merchant)
                 {

                   allow_select_location = true;

                   var new_cart = [];
                   ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach( (p,p_index)=>{
                      change_product_merchant.products.forEach( (np,np_index)=>{
                        var sku_raw = p.product.sku.substring(0, p.product.sku.indexOf("-"));
                        if(np.product.sku.includes(sku_raw))
                        {
                          new_cart.push({
                              product: np.product,
                              quantity: np.new_qty
                           });
                        }
                      });
                    });

                   ShoppingCart.cart[ShoppingCart.active_shopping_cart].products = new_cart;
                   ShoppingCart.setCart(ShoppingCart.cart);

                 }

             }
        }
        else
        {
          allow_select_location = true;
        }
        
        if(allow_select_location)
        {

            this.submitting = true;
            setTimeout(()=>{

              Location.setLocation(this.location);
              Merchant.setMerchant(this.merchant);
              this.$emit('onSelectLocation', this.location);
              this.submitting = false;
            },200);

        }
    }
  },
  mounted () {
    try {
      var province_request = LocationAPI.getProvinces()
      province_request.then((response) => {
        if (response.length) {
          this.province_list = response
        }
      })
    } catch (error) {

    }
  }
}
</script>
<template>

    <!-- MODAL AREA START (Locations Modal) -->
     <div class="location-modal-wrapper">
      <div class="ltn__modal-area ltn__location-modal-area">
          <div class="modal fade show" id="location_modal" tabindex="-1" style="display:block;">
              <div class="modal-dialog modal-md" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <button type="button" class="close" v-if="allowClose" @click="closeModal()" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                          </button>
                      </div>
                      <div class="modal-body">
                           <div class="ltn__quick-view-modal-inner">
                               <div class="modal-location-select">
                                  <div class="row">
                                      <div class="col-12">
                                           <div class="modal-location-form">
                                              <h5>Select Delivery Address</h5>
                                              <select @change="loadCities" class="c-select" v-model="location.province.province_code">
                                                <option selected disabled value="">Province</option>
                                                <option v-for="province in province_list" :value="province.psgcCode">{{ province.provDesc }}</option>
                                              </select>
                                              <select @change="loadBarangay" class="c-select" :disabled="!city_list.length" v-model="location.city.city_code">
                                                <option selected disabled  value="">City</option>
                                                <option v-for="city in city_list" :value="city.citymunCode">{{ city.citymunDesc }}</option>
                                              </select>
                                              <select @change="loadLocationData" class="c-select" :disabled="!barangay_list.length" v-model="location.barangay.brgy_code">
                                                <option selected disabled  value="">Barangay</option>
                                                <option v-for="barangay in barangay_list" :value="barangay.brgyCode">{{ barangay.brgyDesc }}</option>
                                              </select>
                                              <div class="btn-wrapper">
                                                  <button :disabled="submitting || (location.province.province_code == '' || location.city.city_code == '' || location.barangay.brgy_code == '')" @click="selectLocation" class="theme-btn-1 btn btn-effect-1">{{ submitting ? 'Loading...' : 'Submit' }}</button>
                                              </div>
                                           </div>
                                      </div>
                                  </div>
                               </div>
                           </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal-backdrop fade show">
      </div>
      <ConfirmDialogue ref="confirmDialogue" />
     </div>
    <!-- MODAL AREA END -->
</template>

<style>
.location-modal-wrapper {
    position: relative;
    z-index: 10000;
}
.modal-location-form select {
    width: 100%;
    height: 3rem;
    margin-bottom: 1rem;
    padding: 0px 10px;

}

.location-modal-wrapper .modal-location-form .btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
.location-modal-wrapper .modal-location-form .btn-wrapper button {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LocationModal.vue